import React, { useEffect, useCallback, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
// styles
import useStyles from "./styles";
import { getMuiTheme } from "./styles";
import Button from '@material-ui/core/Button';

import {DialogTitle, Dialog,useTheme,Grid } from '@material-ui/core';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import CircularProgress from '@material-ui/core/CircularProgress';
import { toast } from "react-toastify";
import { pathOr } from "ramda";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { setUserTabs } from "../../../../store/actions/dashboard.actions";

import JSONInput from 'react-json-editor-ajrm';
import locale    from 'react-json-editor-ajrm/locale/en';
import { set } from 'date-fns';

export default function ManageTabs({ openManageTabDashlet, setOpenManageTabDashlet,dashboardTabsPages,currentAppType,tabsSequence,setTabsSequence}) {
    const { editDashletLoading, configureDashletLoading } = useSelector((state) => state.dashboard);
    console.log("parentMenuName",currentAppType,dashboardTabsPages)
    const classes = useStyles();
    const currentTheme = useTheme();
    const tabs=[]
    useEffect(()=>{
        dashboardTabsPages.filter(item=>(item['parentMenuName']===currentAppType) || (!item['parentMenuName'] || item['parentMenuName']==='Home')
        ).map((tab)=>{
            tabs.push(tab['pageTitle']);
        })
    },[dashboardTabsPages])
    // const [toast, setToast] = useState({ toastVisible: false, toastMessage: '' });
    const { isAuthenticated } = useSelector((state) => state.auth);
   
    const dispatch = useDispatch();
    const submitForm = (()=>{
        try {
      
            dispatch(setUserTabs(tabsSequence)).then(function (res) {
                if (res.ok) {
                    console.log('resManageTabs',res.data)
                    setTabsSequence(res.data)
                } else {
                    toast('Something went wrong!');
                  
                }
            })
            } catch (e) {
            toast('Something went wrong!');
        }
    })
    const handleClose = () => {
        setOpenManageTabDashlet(false);
    };
    return (
        <>
            <MuiThemeProvider theme={getMuiTheme(currentTheme)}>
            <Dialog fullWidth={false} maxWidth={"md"} open={openManageTabDashlet} onClose={handleClose} aria-labelledby="form-dialog-title" >
            <DialogTitle id="alert-dialog-title">Manage Tab Sequence</DialogTitle>
                <DialogContent>
            <Grid container spacing={1} >
<Grid item xs={12}  >
<JSONInput
id          = 'jsonData'
placeholder = {tabs}
// placeholder = {{...customDashletOptions[customDashletType],['result']:[]}}
locale      = { locale }
height      = '400px'
onChange={(val) => setTabsSequence(val.jsObject)}
/>


</Grid>
</Grid>
</DialogContent>
<DialogActions>
                        {/* {   addDashboardLoading ?
                                <Button className={classes.whitetextcolor} variant="contained" size="small" color="primary" disabled={!value} type='submit'>
                                    Adding <CircularProgress size={14} style={{ marginLeft: 10, color:"White" }} />
                                </Button>
                            : */}
                                <Button className={classes.whitetextcolor} variant="contained" size="small" color="primary" type='submit' onClick={submitForm}>Submit</Button>
                                {/* onClick={submitForm} */}
                        {/* } */}
                        <Button className={classes.whitetextcolor} variant="contained" size="small" autoFocus onClick={handleClose} color="primary">Close</Button>
                    </DialogActions>
            </Dialog>
            </MuiThemeProvider>
        </>
    );
}